import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { push } from 'react-router-redux';
import _ from 'lodash';
import { Scrollbars } from 'shared/vendor/react-custom-scrollbars/src/index';
import Paper from 'material-ui/Paper';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import Tooltip from 'material-ui/internal/Tooltip';
import RenderToLayer from 'material-ui/internal/RenderToLayer';
import Divider from 'material-ui/Divider';
import { List } from 'material-ui/List';
import Add from 'material-ui/svg-icons/content/add';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import ActionInfo from 'material-ui/svg-icons/action/info-outline';
import * as Colors from 'material-ui/styles/colors';
import routes from 'App/routeConstants';
import LeftMenuItem from 'shared/components/LeftMenu/LeftMenuItem';
import { unselectAllImages, changeFolder } from 'MyAccount/ViewDesigns/redux/modules/images';
import { openLazyPanel } from 'crazyEditor/redux/modules/panel/panel';
import RenameIcon from './RenameIcon';
import { getFolderListNames } from '../selectors';
import { openDialog } from '../helpers';
import {
  NAV_MENU_HEIGHT,
  TOP_NAV_HEIGHT,
  LEFT_MENU_WIDTH,
  DELETE_FOLDER_DIALOG,
  NEW_FOLDER_DIALOG,
  RENAME_FOLDER_DIALOG,
  TRASH_FOLDER,
} from '../consts';
import { PANELS } from 'crazyEditor/components/ImageManagerDialogs/ImageManagerPanels';
import connectWithRouter from 'shared/components/redux/connectWithRouter';

const getStyles = ( integrated ) => ({
  height: integrated ? '100%' : `calc(100vh - ${NAV_MENU_HEIGHT + TOP_NAV_HEIGHT}px)`,
});

const styles = {
  leftMenu: {
    width: LEFT_MENU_WIDTH,
    transition: '350ms cubic-bezier(0.23, 1, 0.32, 1)',
    transform: 'translateX(0px)',
    height: '100%',
    backgroundColor: Colors.grey200,
    overflow: 'auto',
    zIndex: 1,
  },
  folderDropDown: {
    padding: '0px 16px 0px 55px',
  },
  unsortedRightButton: {
    position: 'absolute',
    top: 0,
    right: 5,
  },
};

@connectWithRouter(
  (state, ownProps) => ({
    folderList: getFolderListNames(state, ownProps.resourceType),
    pathname: state.routing.location.pathname,
  }),
  { push, unselectAllImages, changeFolder, openLazyPanel },
)
export default class Sidebar extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  state = {
    showUnsortedIconTooltip: false,
    unsortedTooltipPosition: {marginLeft: 0, marginRight: 0},
  };

  getFolderContentMenu(folder) {
    const { folderList, currentFolder, resourceType } = this.props;
    const lastFolder = folderList[folderList.length - 1];
    const nextFolderIsCurrent = folderList[_.indexOf(folderList, folder) + 1] === currentFolder;
    return resourceType === 'Icons' ? null : {
      menuIcon: <IconButton
                  tooltip="More"
                  tooltipPosition={ lastFolder === folder || nextFolderIsCurrent ? 'top-center' : 'bottom-center'}
                >
                  <MoreVertIcon />
                </IconButton>,
      menuItems: [
        <MenuItem
          primaryText="Rename"
          key={1}
          leftIcon={<RenameIcon />}
          onClick={this.openRenameFolderDialog.bind(this, folder)}
        />,
        <MenuItem
          primaryText="Delete"
          key={2}
          leftIcon={<DeleteIcon />}
          onClick={this.openDeleteFolderDialog.bind(this, folder)}
        />],
      useLayerForClickAway: true,
    };
  }

  getFolders() {
    const { currentFolder, folderList, resourceType } = this.props;
    const folders = [];
    let trashFolder;
    _.forOwn(folderList, (folder, index) => {
      const folderLength = resourceType === 'Icons' ? 22 : 17;
      const selected = (resourceType === 'Icons' && !currentFolder) ? Number(index) === 0 : folder === currentFolder;
      if (folder === TRASH_FOLDER) {
        trashFolder = (
          resourceType === 'Icons' ? null : <LeftMenuItem
            key={folder}
            primaryText={folder}
            leftIcon={<DeleteIcon />}
            selected={selected}
            onClick={() => this.changeFolder(folder)}
          />
        );
      } else {
        folders.push(
          <LeftMenuItem
            key={folder}
            selected={selected}
            onClick={() => this.changeFolder(folder)}
            hiddenMenuElements={this.getFolderContentMenu(folder)}
            primaryText={folder}
          />
        );
      }
    });
    if (trashFolder) folders.push(trashFolder);
    return folders;
  }

  openNewFolderDialog = () => {
    const { integrated, openLazyPanel } = this.props;
    if (integrated) {
      openLazyPanel(PANELS.NEW_FOLDER, null, null, {});
    } else {
      openDialog({
        dialogName: NEW_FOLDER_DIALOG,
      });
    }
  };

  openDeleteFolderDialog = (folderName) => {
    const { integrated, openLazyPanel, currentFolder } = this.props;
    if (integrated) {
      openLazyPanel(PANELS.DELETE_FOLDER, null, null, { folderName, currentFolder: currentFolder });
    } else {
      openDialog({
        dialogName: DELETE_FOLDER_DIALOG,
        folderName: folderName,
      });
    }
  };

  openRenameFolderDialog = (folderName) => {
    const { integrated, openLazyPanel, currentFolder } = this.props;
    if (integrated) {
      openLazyPanel(PANELS.RENAME_FOLDER, null, null, { folderName, currentFolder: currentFolder });
    } else {
      openDialog({
        dialogName: RENAME_FOLDER_DIALOG,
        folderName: folderName,
      });
    }
  };

  toggleUnsortedIconTooltip = (e) => {
    e.stopPropagation();
    const position = ReactDOM.findDOMNode(this.refs.unsortedButton).getBoundingClientRect();
    this.setState({
      showUnsortedIconTooltip: !this.state.showUnsortedIconTooltip,
      unsortedTooltipPosition: { marginTop: position.top, marginLeft: position.left + 10 },
    });
  };

  closeUnsortedIconTooltip = () => {
    this.setState({ showUnsortedIconTooltip: false });
  };

  unselectAllImages = () => {
    this.props.unselectAllImages();
  };

  changeFolder(folderName) {
    if (this.props.integrated) {
      const { resourceType } = this.props;
      this.props.changeFolder({folderName, resourceType});
    } else {
      let route = routes.MyAccount.AssetManagerBase;
      if (folderName) {
        route += `/${encodeURIComponent(folderName)}`;
      }
      this.context.router.push(route);
    }
    this.props.unselectAllImages();
  }

  renderTrackVertical({ style, ...props }) {
    const finalStyle = {
      ...style,
      right: 2,
      bottom: 2,
      top: 2,
      borderRadius: 3,
      zIndex: 9999,
    };
    return <div style={finalStyle} {...props} />;
  }

  renderUnsortedTooltip = () => {
    const { showUnsortedIconTooltip } = this.state;
    return (
      <Tooltip
        label="This is your default image folder"
        show={showUnsortedIconTooltip}
        verticalPosition="bottom"
        horizontalPosition="center"
        style={this.state.unsortedTooltipPosition}
      />
    );
  };

  render() {
    const { showUnsortedIconTooltip } = this.state;
    const { currentFolder, integrated, resourceType } = this.props;
    const dynStyles = getStyles( integrated );

    return (
      <div style={dynStyles} onClick={this.unselectAllImages}>
        <Paper style={styles.leftMenu} rounded={false} zDepth={0} >
          <Scrollbars renderTrackVertical={this.renderTrackVertical} horizontalScroll={false}>
            <List style={{ paddingTop: 0 }} >
              { resourceType === 'Icons' ? null : <LeftMenuItem
                primaryText="Unsorted"
                selected={typeof currentFolder === 'undefined'}
                style={showUnsortedIconTooltip ? { zIndex: 2 } : { zIndex: 1 }}
                onClick={() => this.changeFolder()}
                rightIconButton={
                  <IconButton
                    onClick={this.toggleUnsortedIconTooltip}
                    style={styles.unsortedRightButton}
                    onBlur={this.closeUnsortedIconTooltip}
                    ref="unsortedButton"
                  >
                    <RenderToLayer
                      componentClickAway={() => {}}
                      useLayerForClickAway={false}
                      render={this.renderUnsortedTooltip}
                      open
                    />
                    <ActionInfo color={Colors.grey400} />
                  </IconButton>
                }
              />}
              {this.getFolders()}
              <Divider/>
              {resourceType === 'Icons' ? null : <LeftMenuItem
                primaryText={'New folder'.toUpperCase()}
                leftIcon={<Add />}
                onClick={() => this.openNewFolderDialog()}
              />}
              {resourceType === 'Icons' ? null : <Divider/>}
            </List>
          </Scrollbars>
        </Paper>
      </div>
    );
  }
}

Sidebar.PropTypes = {
  currentFolder: PropTypes.string,
  folderList: PropTypes.arrayOf(PropTypes.string),
};